:host {
  contain: content;
  display: flex;
  padding: 8px 0px;
  gap: 6px;

  color: var(--theme-secondary-text);
  font-family: Inter;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 14px;
  align-items: center;

  white-space: nowrap;
  border-bottom: 1px solid var(--theme-light-border);
}

/* I supply my own padding if I'm an only child, see the .single rule in aha-chart-tooltop.css */
:host(:only-child) {
  padding: 8px;
}

strong {
  font-weight: 700;
}

::slotted([slot='value']) {
  font-weight: 700;
  margin-left: auto;
}

::slotted([slot='icon']) {
  width: 12px;
  text-align: center;
}
